/**
 * 响应对象
 *
 * @param {Object} res 原生返回的响应对象
 */
function Response(res) {
  let this$1 = this;

  for (let name in res) {
    this$1[name] = res[name];
  }
}

/**
 * 获取响应的 json 对象
 *
 * @return {Object}
 */
Response.prototype.json = function() {
  if (!this.body) { return {}; }

  return JSON.parse(this.body);
};

/**
 * 获取响应的文本
 *
 * @return {String}
 */
Response.prototype.text = function() {
  return this.body;
};

export default function ajaxRequest (options, callback) {
	let result = null, xhr = new XMLHttpRequest(), abortTimeout = null, protocol = /^([\w-]+:)\/\//.test(options.url) ? RegExp.$1 : window.location.protocol;
	xhr.open('GET', options.url);
	// 不用携带COOKIE
	xhr.withCredentials = false;
	xhr.onreadystatechange = function(){
		if (xhr.readyState == 4) {
		    // 删除定时器
		    if (abortTimeout) {
		        clearTimeout(abortTimeout);
		        abortTimeout = null;
		    }
		    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304 || (xhr.status == 0 && protocol == 'file:')) {
		        result = xhr.responseText;
		        xhr.onreadystatechange = null;
		        callback(null, new Response({
		            body: xhr.responseText,
		            status: xhr.status,
		            readyState: xhr.readyState,
		            headers: {}
		        }));
		    } else {
		        callback(new Error(`[pwm-widget-loader] fetch status code[${xhr.status}] error, url: ${options.url}`));
		    }
		}
	};
	// 设置超时定时器
	abortTimeout = setTimeout(function(){
		xhr.onreadystatechange = null;
		xhr.abort();
		callback(new Error(`[pwm-widget-loader] fetch 3s timeout error, url: ${options.url}`));
	}, options.timeout || 3000);
	xhr.send(null);	
}